import type { RouteRecordRaw } from 'vue-router'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { insertIf } from '@backmarket/utils/collection/insertIf'

import { GIFT_CARDS } from './routes.constants'

export default (): RouteRecordRaw[] => {
  const experiments = useExperiments()
  const isGiftCardsEnabled =
    experiments['experiment.giftCards'] === 'withGiftCards'

  return [
    ...(insertIf(isGiftCardsEnabled, [
      {
        path: 'gift-cards',
        name: GIFT_CARDS.INDEX,
        component: () => import('./pages/GiftCards/GiftCards.vue'),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
        },
      },
    ]) as RouteRecordRaw[]),
  ]
}
